// src/auth/displayKey.js
//
// The wall screen's credential.
//
// Microsoft caps a single-page app's refresh token at 24 hours and offers no
// way to raise it, so a screen signed in as a user lands on a login page every
// morning with nobody there to click through. A paired screen holds a key
// instead: issued once, kept in localStorage, valid until an admin revokes it.
// Nothing about it keeps time.
//
// localStorage rather than a cookie or the URL: it is never sent to a server
// that did not ask for it, never appears in a bookmark, a screenshot or a
// photo of the screen, and never lands in nginx's access log.

const STORAGE_KEY = 'vero.display.key'
const NAME_KEY = 'vero.display.name'

export function getDisplayKey() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || ''
  } catch {
    // Storage disabled, private mode, or a browser that throws on access.
    return ''
  }
}

export function hasDisplayKey() {
  return getDisplayKey() !== ''
}

export function displayName() {
  try {
    return window.localStorage.getItem(NAME_KEY) || ''
  } catch {
    return ''
  }
}

export function setDisplayKey(key, name) {
  window.localStorage.setItem(STORAGE_KEY, key)
  window.localStorage.setItem(NAME_KEY, name ?? '')
}

export function clearDisplayKey() {
  try {
    window.localStorage.removeItem(STORAGE_KEY)
    window.localStorage.removeItem(NAME_KEY)
  } catch {
    // Nothing to clear.
  }
}
